import React from 'react';

import i18n from '../../i18n';

// @mui
import {
    FormControl,
    FormControlLabel,
    FormHelperText,
    Checkbox,
} from '@mui/material';

export default class DialogCheckboxField extends React.Component {


    handleCheckboxChanged(event, value) {
        this.props.onChange(event.target.id, value);
    }

    render() {
        // field, value, cache, onChange

        let translatedName = i18n.t(`columns.${this.props.field.label}`);
        // `disabled` carries the template lock and per-field disable that
        // FormField computes; this component used to read only `onlyRead`, so a
        // locked boolean stayed clickable.
        const onlyRead =
            !!this.props.field.onlyRead || !!this.props.disabled;

        const checkbox = (
            <FormControlLabel
                key={this.props.field.label}
                control={
                    <Checkbox
                        disabled={onlyRead}
                        id={this.props.field.id}
                        checked={this.props.value || false}
                        onChange={(event, checked) => this.handleCheckboxChanged(event, checked)}
                    />}
                label={translatedName}
            />
        );
        // A hint under the box, for a flag whose effect is not obvious from its name.
        if (!this.props.field.helperText) {
            return checkbox;
        }
        return (
            <FormControl>
                {checkbox}
                <FormHelperText sx={{ mt: 0 }}>
                    {i18n.t(`helperTexts.${this.props.field.helperText}`)}
                </FormHelperText>
            </FormControl>
        );
    }
}
